<template>
  <div class="user-recover-pass-init_urp">

    <page-header>
      <nav-inner
          :links="[
          { url: '/user/authenticate', text: 'Войти' },
          { url: '/user/register', text: 'Регистрация' },
        ]"/>
    </page-header>

    <div v-if="showForm" class="page-container_pcr" @keyup.enter="submit">

      <app-inputs ref="inputs">

        <div class="block-wrap">

          <app-input
              widget="AppMailSimple"
              :options="{ name: 'mail', title: 'Ваш e-mail в системе',
                required: true }"/>

          <div class="buttons-wrap">
            <button class="vivid-button" @click="submit">Выслать ссылку</button>
            <el-tooltip
                placement="top"
                :enterable="false"
                :open-delay="300">
              <div slot="content">На указанный e-mail<br>
                вам будет выслана ссылка<br>для обновления пароля.</div>
              <i class="info-anchor_ina ina--always-white el-icon-question"></i>
            </el-tooltip>
          </div>

        </div>

      </app-inputs>

    </div>

    <div class="block-wrap" v-if="!showForm">
      <div class="buttons-wrap">
        <div style="margin-bottom: 30px;">Ссылка для обновления пароля выслана на
          указанный e-mail. Чтобы восстановить доступ, перейдите к нашему письму
          и следуйте дальнейшим указаниям. Если письмо не пришло, можете выслать
          повторное письмо через 5 минут.</div>
        <button
            class="vivid-button"
            @click="$router.push({ path: '/user/authenticate' })">
          Вернуться к форме входа</button>
      </div>
    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import AppInputs from '../inputs/AppInputs';
import AppInput from '../inputs/AppInput';

export default {

  components: { PageHeader, PageFooter, NavInner, AppInputs, AppInput },

  data() {
    return {
      showForm: true,
    };
  },

  methods: {

    submit() {
      if (!this.$refs.inputs.hasErrors()) {
        const { mail } = this.$refs.inputs.getValues();
        axios.get(`users/recover-pass/init/${mail}`).then(() => {
          this.showForm = false;
        }).catch((e) => {
          this.$message(e.response.data);
        });
      }
    },

  },

};
</script>

<style lang="scss">
.user-recover-pass-init_urp {
  .block-wrap {
    max-width: 700px;
  }
  .buttons-wrap {
    margin: 20px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserRecoverPassInit.vue